import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Team } from './team.model';

export class TeamStateModel extends EntityStateModel<Team> {
    rootTeams?: Team[];
}
